/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRoleRequestDto
 */
export interface UpdateRoleRequestDto {
    /**
     * Role ID
     * @type {string}
     * @memberof UpdateRoleRequestDto
     */
    id: string;
    /**
     * Role name
     * @type {string}
     * @memberof UpdateRoleRequestDto
     */
    name?: string;
    /**
     * Role description
     * @type {string}
     * @memberof UpdateRoleRequestDto
     */
    description?: string;
    /**
     * Role rights
     * @type {Array<string>}
     * @memberof UpdateRoleRequestDto
     */
    rightsIds?: Array<string>;
    /**
     * Role provider IDs
     * @type {Array<string>}
     * @memberof UpdateRoleRequestDto
     */
    providerIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateRoleRequestDto interface.
 */
export function instanceOfUpdateRoleRequestDto(value: object): value is UpdateRoleRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateRoleRequestDtoFromJSON(json: any): UpdateRoleRequestDto {
    return UpdateRoleRequestDtoFromJSONTyped(json, false);
}

export function UpdateRoleRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoleRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rightsIds': json['rightsIds'] == null ? undefined : json['rightsIds'],
        'providerIds': json['providerIds'] == null ? undefined : json['providerIds'],
    };
}

export function UpdateRoleRequestDtoToJSON(json: any): UpdateRoleRequestDto {
    return UpdateRoleRequestDtoToJSONTyped(json, false);
}

export function UpdateRoleRequestDtoToJSONTyped(value?: UpdateRoleRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'rightsIds': value['rightsIds'],
        'providerIds': value['providerIds'],
    };
}

